import { newTour } from "@/utils/shepherd/main";

export default {
  name: "drawer",
  namespaced: true,
  state: {
    isOpen: false,
    openPurpose: "",
  },
  mutations: {
    SET_IS_OPEN(state, payload) {
      state.isOpen = payload;
    },
    SET_OPEN_PURPOSE(state, payload) {
      state.openPurpose = payload;
    },
  },
  actions: {
    reset({ commit }) {
      commit("SET_IS_OPEN", false);
      commit("SET_OPEN_PURPOSE", "");
    },
    openDrawer({ commit }) {
      commit("SET_IS_OPEN", true);
    },
    createMake({ commit }) {
      commit("SET_IS_OPEN", true);
      commit("SET_OPEN_PURPOSE", "createMake");
    },
    openMakes({ commit }) {
      commit("SET_IS_OPEN", true);
      commit("SET_OPEN_PURPOSE", "makes");
    },
    setInfo({ commit }) {
      commit("SET_IS_OPEN", true);
      commit("SET_OPEN_PURPOSE", "setInfo");
      newTour();
    },
  },
  modules: {},
  getters: {},
};
